import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { IMapOptions } from "../interfaces/mapoptions";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { composePathPoi } from "../api/utility";
import { YelpSearch } from "../interfaces/yelp";

interface IHalfwayPoiLinkProps {
    result: YelpSearch;
}

const HalfwayPoiLink = ({ result }: IHalfwayPoiLinkProps) => {
    const { adr1, adr2, poiname, travel } = useParams();
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);
    const url = composePathPoi(adr1, adr2, poiname, travel, result.id, mapoptions.code);
    return <Link to={url} className="halfwaypoilink">{result.name}</Link>;
};

export default HalfwayPoiLink;
